import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function PublicHeader({ workshopName, logoUrl, logoBgColor, subtitle }) {
  const { t } = useTranslation();

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: theme.colors.primary,
        padding: '16px 20px',
        color: 'white',
      }}
    >
      <Box sx={{ maxWidth: '600px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '12px' }}>
        {logoUrl && (
          <Box
            component="img"
            src={logoUrl}
            alt={workshopName || ''}
            sx={{
              maxHeight: '80px',
              maxWidth: '120px',
              objectFit: 'contain',
              borderRadius: '4px',
              padding: '2px 4px',
              backgroundColor: logoBgColor || 'transparent',
            }}
          />
        )}
        <Box>
          <Typography sx={{ fontSize: '20px', fontWeight: '700' }}>
            {workshopName || t('public_maintenance.workshop')}
          </Typography>
          <Typography sx={{ fontSize: '13px', opacity: 0.8, marginTop: '2px' }}>
            {subtitle || t('public_maintenance.maintenance_tracking')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default PublicHeader;
